import axios from "axios";

// const baseURL = "http://103.73.189.37/TCMS_WEBTRACKER_API/api";

// for developement
// const baseURL = "http://localhost:5000/api/";

//Testing
// const baseURL = "http://targettest.asktek.net/teeparam.tracking.tcms.api/api/";

//Demo
// const baseURL = "http://targetdemo.asktek.net/teeparam.tracking.tcms.demo.api/api/";

// for teeparam test  build use
// const baseURL = "http://154.61.174.151/teeparam.tracking.tcms.api/api/";

// for teeparam live build use
const baseURL = "https://tracking.teeparam.com/TCMS_WEBTRACKER_API/api/";

const instance = axios.create({
  baseURL,
});

export default {
  instance,
  baseURL,
};
